import {combine} from 'effector';
import {createGate} from 'effector-react';

import {fetchBillingHistory, getCurrentBilling, getTotalBilling} from 'api/billing';
import {createGridTableModel} from 'core/hooks/grid2.0';
import {rootDomain} from 'core/rootDomain';
import {BillingPageableContent, BillingRawRow} from 'types/billing';

const domain = rootDomain.createDomain('billingTableDomain');

export const loadBillingDataFx = domain.createEffect({
    name: 'loadBillingDataFx',
    handler: fetchBillingHistory,
});

export const loadBalanceDataFx = domain.createEffect({
    name: 'loadBalanceDataFx',
    handler: getCurrentBilling,
});

export const loadTransactionsBalanceFx = domain.createEffect({
    handler: ({
        allOrganizations,
        legalIdentityId,
    }: {
        allOrganizations: boolean;
        legalIdentityId?: number | null;
    }) => (allOrganizations ? getTotalBilling() : getCurrentBilling(legalIdentityId ?? undefined)),
});

export const transactionsBalance$ = domain.createStore<number>(0);

export const updateBalance = domain.createEvent();

export const {
    pageNumber$,
    pageNumberChanged,
    pageSize$,
    pageSizeChanged,
    filters$,
    filtersChanged,
    filtersReset,
    defaultFilters,
    sortings$,
    sortingsChanged,
    sortingsReset,
    defaultSortings,
    tableStateChanged,
    stateReset,
} = createGridTableModel({
    domain,
});

export const BillingGate = createGate('BillingGate');

export const billingList$ = domain.createStore<BillingPageableContent<BillingRawRow> | null>(null);
export const balance$ = domain.createStore<number>(0);

export const billingState$ = combine({
    data: billingList$,
    loading: loadBillingDataFx.pending,
});

export const tableState$ = combine({
    data: billingList$,
    pageNumber: pageNumber$,
    pageSize: pageSize$,
    filters: filters$,
    sortings: sortings$,
});
